import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarArchivo } from '../../../actions/colaboradores';

const EliminarArchivo = ({ archivo, reestablecerArchivo }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar archivo */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarArchivo({
            id_colaborador: archivo?.id_colaborador, 
            id_archivo: archivo?.id_archivo
        }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerArchivo(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(archivo != null){
            setEliminarModal(true);
        }
    }, [archivo]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar archivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el archivo {archivo?.nombre}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarArchivo;